
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqMrFLbgFDIfvYk5ylzIe9Me7nZo7bX1IV1GDMeIIGpr4Meta } from "/codebuild/output/src3939204543/src/src/pages/faq.vue?macro=true";
import { default as menu1S6asDOSouwC3v2wZbiCiyhA5Ylax_45_45Rvgq3zGcFKh8Meta } from "/codebuild/output/src3939204543/src/src/pages/menu.vue?macro=true";
import { default as index1AD6gEdSNvZX_45OWQ_StV7TvVTnRwyRsRB_45wjP_XcADcMeta } from "/codebuild/output/src3939204543/src/src/pages/index.vue?macro=true";
import { default as contact0dw6o03_Ds9QGEvGiyPiCY6yhpx3neD1_8toxkNO_8sMeta } from "/codebuild/output/src3939204543/src/src/pages/contact.vue?macro=true";
import { default as tutorialmd7_45_z7NsKlStTdnQKnLr6AySjskjl1iX5goyn7T6FYMeta } from "/codebuild/output/src3939204543/src/src/pages/tutorial.vue?macro=true";
import { default as agreementR7Vdmy5772fQgCwEPU9YYOOodK2CE4UVYulfRiXH2WgMeta } from "/codebuild/output/src3939204543/src/src/pages/agreement.vue?macro=true";
import { default as about_45passVoITZG3cI4vLsbqXEHGkS4_452vblqKrV0bojWUBVOTbAMeta } from "/codebuild/output/src3939204543/src/src/pages/about-pass.vue?macro=true";
import { default as index0hzchnM7nCryZAPo_45lfEvrDFoDyXAcUjTHoY63v1or0Meta } from "/codebuild/output/src3939204543/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93rLkS1N_XjLx6husjHhKRyrijRzMLCCzro6djIGlywjgMeta } from "/codebuild/output/src3939204543/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancemjCIfMfADJrkhTwf7ZTowUEXFztKRu6Nn6OxgnObyfMMeta } from "/codebuild/output/src3939204543/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93D4xea_MCFeXgltlZaUju6WvxwCP19AAWOASOS7e6z1YMeta } from "/codebuild/output/src3939204543/src/src/pages/notice/[id].vue?macro=true";
import { default as indexV4sunM2bZm98_4552aK4CMKkRe9yjF6UnuGqWf_dkzykQMeta } from "/codebuild/output/src3939204543/src/src/pages/coupon/index.vue?macro=true";
import { default as indexGkx3kzLRGuW7jXxNG6QVk_45Nab7BALlZy3KVosal8t6kMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/index.vue?macro=true";
import { default as indexn7OZwWH67mX74S_YHpB3RN3f7sesxKky6FrDFlMZUKAMeta } from "/codebuild/output/src3939204543/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93S39oiZsaV69zw6F71q_SqiIXrw8kfEdnrHUdYUGFVGoMeta } from "/codebuild/output/src3939204543/src/src/pages/parking/[id].vue?macro=true";
import { default as indexEW2GwZE_L8h6gFKLoFkg_j6BbgS4WsC48CRyCa31l2kMeta } from "/codebuild/output/src3939204543/src/src/pages/history/index.vue?macro=true";
import { default as indexQXJPIhKjl3BMtK0fsZq9IPUXAPTvUYFy86SYpRvTSRQMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/index.vue?macro=true";
import { default as indexJxGcGC0NCjLKNb08WUwq0c8tTydBnqWkmNL1zDZMgHsMeta } from "/codebuild/output/src3939204543/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexZVTzbbTdltdFQpvNzvQGhbWwZQuQT90xb_QIk_45vlNLAMeta } from "/codebuild/output/src3939204543/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavitaASHyBDrpekw5cbK_45aJrMAtMQpjwA5ABzHVhruHJ4gMeta } from "/codebuild/output/src3939204543/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editXc8e6O7QbV_Zxjw8iyYPekgkemhhKc_wtiMCufSPvTEMeta } from "/codebuild/output/src3939204543/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementbz2xsieuMOh9qqFZX9pgvuKffUj7hMq7l6GRyLVqfrwMeta } from "/codebuild/output/src3939204543/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexrE571pVig26DzdGuNkMhgx_45BCpgHvLTE8X1X7phqrUYMeta } from "/codebuild/output/src3939204543/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dIwKduRUN5_v2iT04Cl6T4Z2RBLf_R77rqVTLY_8vCtoMeta } from "/codebuild/output/src3939204543/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmWMXqbZd1iz243rKmljTUGy9XWDnkGay_E78RB3j9N_458Meta } from "/codebuild/output/src3939204543/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexLkihUhHYuf0ldrVWzMKxGHWDmBwJIqJFDRGbBI_93o4Meta } from "/codebuild/output/src3939204543/src/src/pages/card/create/index.vue?macro=true";
import { default as indexQkg9uOQHLfeqyKsYLwVDTtr7UImq_JYlU7TyePhxgqYMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm8VdWucoZ_45ZfxZD_VvWlSSrHprApG9j7VUNNMSVddZ0wMeta } from "/codebuild/output/src3939204543/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmHgvHSmLI_455zddtAxQQgF_EGBAqNmTnyGcOPBPaAp9r8Meta } from "/codebuild/output/src3939204543/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completepQoSmmpgzHmV4iqRYuZA8UfIp1QS0moXpSNfFhK3peoMeta } from "/codebuild/output/src3939204543/src/src/pages/membership/complete.vue?macro=true";
import { default as registerhkrnF9Y31E2hIju_45hnCEwc363v9P_xKyzdM2g4KqwUQMeta } from "/codebuild/output/src3939204543/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93m27EXC88QSlNIGqnymVvVqdD9Pvd8HaoLu03y8y_AyQMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmQvRH8bi9jpUGzihzZJdZz8ZOhEEWe02_45O_F3u1l28XgMeta } from "/codebuild/output/src3939204543/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93ZM4RQB34NhwdvXJtSgqzDLjb_45kCIGls4_y_YI_45YbQiUMeta } from "/codebuild/output/src3939204543/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexs5UYgJAMzLNWU7j0HANRXoEf_H_45MvwookYggMTrgBUMMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeJxtAj2lv1r747FnAW8gVJNmQ8_45rq0AYBpLlzR4lcDcIMeta } from "/codebuild/output/src3939204543/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeaBJbYZjx41PLGK_450CEl48Hn9BaHKWQuqq_hAEp8bTMUMeta } from "/codebuild/output/src3939204543/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeaqqmtGkWMtfi966Khf4f9UDFdY5OTnGFE9cJLjiI_5wMeta } from "/codebuild/output/src3939204543/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerjt3_2r6lXd_nCKrcxHTkqEtgGXhSXNcSWbRtLKQlGrsMeta } from "/codebuild/output/src3939204543/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete0HfxH2CaOeH0inlxMRvnjnBv0XtgV_ya9UyhGT6OwlkMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexttoGsCHzsTzmWfVkIhlppMc6bKZe9qHkLh_nXTJCSXkMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmyrvZS_45EyRWV_45IB3OM9QTjwmrcQIcMqUSL_45tyDC7NNk4Meta } from "/codebuild/output/src3939204543/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completepnBVdr7sOu565QaoFefK26r83_45CqZEC4EcVpwxDqzE4Meta } from "/codebuild/output/src3939204543/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexUKXIrVUa8s_45Y1IDzWgnqXaF8t7jZmR5N4Xf9VuBWTlUMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Ij_3Vm0JGbiNctMb6nyy8SnNf57Dl1uoOj3DxuapJQsMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeUiB6VUXDxiFxyj7Oldy6s8MFl58s7hJy_dcR05KFxPwMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasDZcRRVmN_N5KFwkJe83WKG04kLDA_45kGdZqTNu44C_SMMeta } from "/codebuild/output/src3939204543/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleaRpMXQOaYdsdPIIz7aFrn4E1SWQJqeubYb6dPtjMGZMMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailiuXf_VcwNkGTDOZeMCF2aj3VljYuBBs_MkgXZKw0hO4Meta } from "/codebuild/output/src3939204543/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmO_8nnyQVqwf0ytQS2OjgqysnUQ63TgVGLN88ZlmCMMUMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenteGW94rA2TsM1bXwGzGYez_45UPEgFuLwf4Uv76IvYe_4500Meta } from "/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmn8tI2dPMcptVQvk_45yjuDMmNb2eYUniE0XHiOYV3gX0oMeta } from "/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateTixZ3kBHX9NQG4yBQhTh67RTT9kLo4L3_45JdY_4547Ij_UMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete0JgL1q1ZwytXgskl8vn4Xvkni6C8Zl3LGOaMgPGStPQMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code1d_l4tiN5NPwDu4keUd00aZ2sopRM8m3YGaRWxZOV9AMeta } from "/codebuild/output/src3939204543/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhZZp0IzjN0AWxcVDl4GXZ78c2Hl6OEFNBwIs199hKbkMeta } from "/codebuild/output/src3939204543/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasRsYywXZfpaZyH1TpaQ0zu0QuNWPfgbR_Wqw1LjYeXWkMeta } from "/codebuild/output/src3939204543/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerfak4IMMqOyTWvIfP1QM6N_Iyx88vrO2dI9tEOXNHCl8Meta } from "/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code_I1MvLEFodEIESrQlHTLLDAPJpV2i8jq1Xf3l7szx5IMeta } from "/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexqU9SazGcFdV_HNxDdvTwb0hXP7Yrug6u5MlF99qiN3kMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexCUIpas3g4xXM2U0E3_I6n7TXKZ8zVK2GMtM6hwo_45e8MMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexzK5KXRpJyh1SYgG2VUz2fZYClIV0U7gMAIBVbA5GqO0Meta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexzxlRxpeebNmegvukouo_452h7hjSWaJJgV1a3aCE8e5G4Meta } from "/codebuild/output/src3939204543/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update72bAWoS2EA4l4jOo8ZRwMiYkt1QQGILEJrNqH_XX8KgMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completerlWRKK_452hPfyBn6gGC6cthPb2f9mvIO_4583rGjhI0NjIMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmbdeys22fXF_Xrhr52TYbon00XdmkU8zIYheUQG7wKboMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexjr7Dgfnj1i5baQ4CiGWEsh0b7LcoImK3x23aZr51sscMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeoXs9ODOa6iERVzOQb5UzoBeuRQ3DhndTy2yAvAVFzt4Meta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateBSnbByissvVqfOsuElLpY5vK_Ubi3QaR5rj1SsBo4uAMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexm2Doa58_45BGjiXWDCgQdwvQ1FIn0j8m6RC7CFBFxT_45AsMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexboOTfjZ98JqX4fGynOqOvRrIIx7kE_5wzZX8qRxsUPUMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeye_45GT0XssOCEDrok_dwe2Xd_45BCdQYmGOmwO5iOw3HHMMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexomHMs9g3Wndcbql0jgovCBHBrzyQNT9kxcmhxJ6EKJoMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeR_yVxL1YOOJnHHnE7imOcf8Y7wKv8yGaFdQKT6mGqRcMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexjG6zR0wVy4mQmoEGuwMauoG0R_ZEd8AyZnuZdkyXmDUMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexKRvQjmvleZknLDUEEaaY0yAZsjpE1MeT_I_45bSyFAeMoMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexdqSQraqyv2SGUi7AVFpApYDJ2UxR5DpjjwjpSe_JLgcMeta } from "/codebuild/output/src3939204543/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateNhQgDYMZIbQqvpJ1l23PIOghwb4P3nz7fUWKtj89qEcMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm6mWnFMh_cTxvAaJTY1HZtVZ4OYJGIQ7WFVhHNsS2e4oMeta } from "/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu1S6asDOSouwC3v2wZbiCiyhA5Ylax_45_45Rvgq3zGcFKh8Meta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1AD6gEdSNvZX_45OWQ_StV7TvVTnRwyRsRB_45wjP_XcADcMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexV4sunM2bZm98_4552aK4CMKkRe9yjF6UnuGqWf_dkzykQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexEW2GwZE_L8h6gFKLoFkg_j6BbgS4WsC48CRyCa31l2kMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexJxGcGC0NCjLKNb08WUwq0c8tTydBnqWkmNL1zDZMgHsMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexZVTzbbTdltdFQpvNzvQGhbWwZQuQT90xb_QIk_45vlNLAMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexLkihUhHYuf0ldrVWzMKxGHWDmBwJIqJFDRGbBI_93o4Meta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm8VdWucoZ_45ZfxZD_VvWlSSrHprApG9j7VUNNMSVddZ0wMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmHgvHSmLI_455zddtAxQQgF_EGBAqNmTnyGcOPBPaAp9r8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completepQoSmmpgzHmV4iqRYuZA8UfIp1QS0moXpSNfFhK3peoMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerhkrnF9Y31E2hIju_45hnCEwc363v9P_xKyzdM2g4KqwUQMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmQvRH8bi9jpUGzihzZJdZz8ZOhEEWe02_45O_F3u1l28XgMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeJxtAj2lv1r747FnAW8gVJNmQ8_45rq0AYBpLlzR4lcDcIMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeaBJbYZjx41PLGK_450CEl48Hn9BaHKWQuqq_hAEp8bTMUMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeaqqmtGkWMtfi966Khf4f9UDFdY5OTnGFE9cJLjiI_5wMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerjt3_2r6lXd_nCKrcxHTkqEtgGXhSXNcSWbRtLKQlGrsMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmyrvZS_45EyRWV_45IB3OM9QTjwmrcQIcMqUSL_45tyDC7NNk4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completepnBVdr7sOu565QaoFefK26r83_45CqZEC4EcVpwxDqzE4Meta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexUKXIrVUa8s_45Y1IDzWgnqXaF8t7jZmR5N4Xf9VuBWTlUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeUiB6VUXDxiFxyj7Oldy6s8MFl58s7hJy_dcR05KFxPwMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleaRpMXQOaYdsdPIIz7aFrn4E1SWQJqeubYb6dPtjMGZMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailiuXf_VcwNkGTDOZeMCF2aj3VljYuBBs_MkgXZKw0hO4Meta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmO_8nnyQVqwf0ytQS2OjgqysnUQ63TgVGLN88ZlmCMMUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenteGW94rA2TsM1bXwGzGYez_45UPEgFuLwf4Uv76IvYe_4500Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmn8tI2dPMcptVQvk_45yjuDMmNb2eYUniE0XHiOYV3gX0oMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete0JgL1q1ZwytXgskl8vn4Xvkni6C8Zl3LGOaMgPGStPQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code1d_l4tiN5NPwDu4keUd00aZ2sopRM8m3YGaRWxZOV9AMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhZZp0IzjN0AWxcVDl4GXZ78c2Hl6OEFNBwIs199hKbkMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerfak4IMMqOyTWvIfP1QM6N_Iyx88vrO2dI9tEOXNHCl8Meta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code_I1MvLEFodEIESrQlHTLLDAPJpV2i8jq1Xf3l7szx5IMeta || {},
    component: () => import("/codebuild/output/src3939204543/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3939204543/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]